module.exports = __webpack_public_path__ + "img/balli_explanation.759bc6a6.png";